import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './en';
import pt from './pt';
import es from './es';

const DEFAULT_LANGUAGE = process.env.REACT_APP_DEFAULT_LANGUAGE || 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: en,
      },
      pt: {
        translations: pt,
      },
      es: {
        translations: es,
      },
    },
    fallbackLng: DEFAULT_LANGUAGE.toLowerCase(),
    supportedLngs: ['en', 'pt', 'es'],
    nonExplicitSupportedLngs: true,
    debug: true,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
